/**
 * API variables in production environment
 */

export const API_BASE_URL = 'https://api.conteudo.vocenarpc.com.br/v1/'
export const APP_URL = 'https://galeria.vocenarpc.com.br'

export default {
  API_BASE_URL,
  APP_URL,
}
/* eslint-enable global-require */
